<template>
  <div class="support-tickets">
    <div v-if="this.isLoading">
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 15px"
        height="110px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 15px"
        height="110px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 15px"
        height="110px"
      />
    </div>
    <div v-else>
      <Toast class="toast-msg" position="bottom-right" />
      <div class="support-tickets__information">
        <h1 class="support-tickets__information-header">
          {{ "#" + this.ticket.issue.id + " " + this.ticket.issue.subject }}
        </h1>
        <div class="support-tickets__information-status">
          <p class="support-tickets__information-status__header">
            Статус обращения:
          </p>
          <p class="support-tickets__information-status__text">
            {{ this.ticket.issue.status.name }}
          </p>
        </div>
        <div class="support-tickets__information-startdate">
          <p class="support-tickets__information-startdate__header">
            Дата обращения:
          </p>
          <p class="support-tickets__information-startdate__text">
            {{ getCreatedDate(this.ticket.issue.created_on) }}
          </p>
        </div>
        <div class="support-tickets__information-enddate">
          <p class="support-tickets__information-enddate__header">
            Последнее обновление:
          </p>
          <p class="support-tickets__information-enddate__text">
            {{ getCreatedDate(this.ticket.issue.updated_on) }}
          </p>
        </div>
        <div
          v-if="this.ticket.issue.custom_fields[0].value"
          class="support-tickets__information-ordernumber"
        >
          <p class="support-tickets__information-ordernumber__header">
            Номер заказа:
          </p>
          <p
            @click="redirectToOrder(this.ticket.issue.custom_fields[0].value)"
            class="support-tickets__information-ordernumber__text"
          >
            {{ this.ticket.issue.custom_fields[0].value }}
          </p>
        </div>
        <div class="support-tickets__information-description">
          <p class="support-tickets__information-description__header">
            Описание:
          </p>
          <p class="support-tickets__information-description__text">
            {{ this.ticket.issue.description }}
          </p>
        </div>
        <div
          v-if="this.ticket.issue.attachments.length > 0"
          class="support-tickets__information-attachments"
        >
          <p class="support-tickets__information-attachments__header">
            Прикреплённые файлы:
          </p>
          <div
            v-for="(attachment, index) in this.ticket.issue.attachments"
            :key="index"
            class="support-tickets__information-attachments__url"
          >
            <a
              @click="downloadFile(attachment.id, attachment.filename)"
              href="#"
              class="support-tickets__information-attachments__url-text"
              >{{ attachment.filename }}</a
            >
          </div>
        </div>
      </div>
      <div
        v-if="this.ticket.issue.journals.length > 0 
          && this.ticket.issue.status.name != 'Отказ'
          && this.ticket.issue.status.name != 'Закрыта'"
        class="support-tickets__information-history"
      >
        <p class="support-tickets__information-history__header">
          История сообщений:
        </p>
        <div v-for="(note, index) in this.ticket.issue.journals" :key="index">
          <!-- <div v-if="note.private_notes == false && note.details.length > 0 && isStatusAssigned(note.details[0].name) == false">
                      <p>{{getCreatedDate(note.created_on) + ":"}}</p>
                        <p>{{"Параметр " + journalNameHandler(note.details[0].name) + " изменился " + journalValueHandler(note.details[0].name, note.details[0].old_value, note.details[0].new_value)}}</p>
                    </div>
                    <div v-else-if="note.details.lengt h == 0">
                      <p>{{getCreatedDate(note.created_on) + ":"}}</p>
                      <p>{{note.notes}}</p>
                    </div> -->
          <div
            v-if="
              note.notes
            "
            class="support-tickets__information-history__message"
          >
            <div
              v-if="note.user.name == this.ticket.issue.author.name"
              class="support-tickets__information-history__usermessage"
            >
              <p class="support-tickets__information-history__message-date">
                {{ getCreatedDate(note.created_on) }}
              </p>
              <p class="support-tickets__information-history__message-user">
                {{ "Вы:" }}
              </p>
              <p class="support-tickets__information-history__message-text">
                {{ note.notes }}
              </p>
            </div>
            <div
              v-else
              class="support-tickets__information-history__supportmessage"
            >
              <p class="support-tickets__information-history__message-date">
                {{ getCreatedDate(note.created_on) }}
              </p>
              <p class="support-tickets__information-history__message-date">
                {{ "BiletDV.ru:" }}
              </p>
              <p class="support-tickets__information-history__message-text">
                {{ note.notes }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="support-tickets__changeble" v-if="this.ticket.issue.status.name != 'Отказ'
          && this.ticket.issue.status.name != 'Закрыто'">
        <form
          @submit.prevent="sendRequest"
          enctype="multipart/form-data"
          method="post"
          class="support-request__form"
          autocomplete="off"
        >
          <div class="support-tickets">
            <Editor
              class="support-tickets__changeble-textarea"
              v-model="description"
              editorStyle="height: 160px"
            >
              <template #toolbar>
                <span class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                  <button class="ql-underline"></button>
                  <button class="ql-list" value="ordered"></button>
                </span>
              </template>
            </Editor>
          </div>

          <div class="support-request__form-upload">
            <p class="support-request__form-upload__title">
              Прикреплённые файлы
            </p>
            <p
              class="support-request__form-upload__alert"
              v-show="this.fileSizeEx"
            >
              Размер файлов не должен привышать 20Мб, размер одного файла - не
              более 10Мб.
            </p>
            <p
              class="support-request__form-upload__alert"
              v-show="this.maxFileCount"
            >
              Количество файлов - не более 10ти.
            </p>
            <p
              class="support-request__form-upload__alert"
              v-show="this.wrongFileFormat"
            >
              Допустимые форматы файлов: .png, .jpg, .jpeg, .pdf, .tif, .tiff,
              .pjpeg, .pjp
            </p>
            <input
              type="file"
              id="files"
              ref="files"
              multiple
              accept=".png, .jpg, .jpeg, .pdf, .tiff, .pjpeg, .pjp"
              @change="handleFileUpload()"
              class="support-request__form-upload__mob-input"
            />
            <label for="files" class="support-request__form-upload__mob"
              >Выбрать файлы</label
            >
            <div v-if="this.showAttachedFiles">
              <div
                v-for="(file, index) in this.files"
                :key="index"
                class="support-request__form-upload__show"
              >
                <p class="support-request__form-upload__show-item">
                  {{ file.name }}
                </p>
              </div>
            </div>
          </div>
          <Button
            type="submit"
            label="Отправить"
            class="refund-main__submitbtn"
            :class="{ disabled: !this.checkBeforeSumbit }"
            :loading="this.isSubmiting"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from "vue";
  import InputText from "primevue/inputtext";
  import axios from "axios";
  import Ripple from "primevue/ripple";
  import Button from "primevue/button";
  import Skeleton from "primevue/skeleton";
  import { useRouter, useRoute } from "vue-router";
  import Dropdown from "primevue/dropdown";
  import Editor from "primevue/editor";
  import { useToast } from "primevue/usetoast";
  import Toast from "primevue/toast";
  import store from "../store";

  const axioCred = axios.create({
    withCredentials: true,
  });

  export default defineComponent({
    name: "SupportTicket",
    components: {
      InputText,
      Button,
      Skeleton,
      Dropdown,
      Editor,
      Toast,
    },
    props: ["ticketId"],
    setup(props) {
      const toast = useToast();
      const showSuccess = () => {
        toast.add({
          severity: "success",
          summary: "Выполнено!",
          detail: "Обращение обновлено",
          life: 3000,
        });
      };
      const isLoading = ref(false);
      const isSubmiting = ref(false);
      const router = useRouter();
      const route = useRoute();
      const isDocsLoading = ref(false);
      const description = ref("");
      const ticket = ref(null);
      const requesterMail = ref(null);
      const getUserTicket = async () => {
        isLoading.value = true;
        try {
          const json = await axioCred.get(
            `https://www.biletdv.ru/customer/IBEServices/GetIssue?id=${props.ticketId}`
          );
          if (json.data) {
            let fetchedOrders = await json.data;

            ticket.value = fetchedOrders;

            isLoading.value = false;
          } else {
            console.log("error!");
            isLoading.value = false;
          }
          console.log(ticket.value);
          isLoading.value = false;
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      };

      const getUserData = () => {
        const data = sessionStorage.getItem("userName");
        if (data !== null) {
          requesterMail.value = JSON.parse(data);
        }
      };

      return {
        isLoading,
        isSubmiting,
        isDocsLoading,
        getUserTicket,
        ticket,
        description,
        requesterMail,
        getUserData,
        showSuccess,
      };
    },
    data() {
      return {
        month: [
          "янв",
          "фев",
          "мар",
          "апр",
          "мая",
          "июн",
          "июл",
          "авг",
          "сен",
          "окт",
          "ноя",
          "дек",
        ],
        wrongFileFormat: false,
        maxFileCount: false,
        fileSizeEx: false,
        checkBeforeSumbit: true,
        files: "",
      };
    },
    methods: {
      downloadFile(id, fileName) {
        axios({
          method: "GET",
          url: `https://www.biletdv.ru/customer/IBEServices/GetProxyDownload?id=${id}&fileName=${fileName}`,
          responseType: 'blob',
          withCredentials: true,
        })
          .then((res) => {
            console.log(res);
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      mixedContentHandler(url) {
        let slicedUrl = url.slice(4);
        let handledUrl = "https" + slicedUrl;
        return handledUrl;
      },
      getWeekDay(date) {
        let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
        let weekDay = new Date(date);
        return days[weekDay.getDay()];
      },
      getDate(date) {
        let month = [
          "янв",
          "фев",
          "мар",
          "апр",
          "мая",
          "июн",
          "июл",
          "авг",
          "сен",
          "окт",
          "ноя",
          "дек",
        ];
        let monthNum = new Date(date);
        return monthNum.getDate() + " " + month[monthNum.getMonth()];
      },
      handleFileUpload() {
        this.files = this.$refs.files.files;
        let filesSize = 0;
        if (this.files.length > 0) {
          this.showAttachedFiles = true;
        } else {
          this.showAttachedFiles = false;
        }
        for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].size > 10485760) {
            this.fileSizeEx = true;
          } else {
            this.fileSizeEx = false;
          }
          if (
            this.files[i].type !== "image/png" &&
            this.files[i].type !== "image/jpg" &&
            this.files[i].type !== "image/jpeg" &&
            this.files[i].type !== "image/pjp" &&
            this.files[i].type !== "image/pjpeg" &&
            this.files[i].type !== "application/pdf" &&
            this.files[i].type !== "image/tiff"
          ) {
            this.wrongFileFormat = true;
          } else {
            this.wrongFileFormat = false;
          }

          filesSize += this.files[i].size;
        }
        if (filesSize > 22020096) {
          this.fileSizeEx = true;
        } else {
          this.fileSizeEx = false;
        }
        if (this.files.length > 10) {
          this.maxFileCount = true;
        } else {
          this.maxFileCount = false;
        }
        if (this.files.length == 0) {
          this.wrongFileFormat = false;
        }
        if (this.maxFileCount || this.fileSizeEx || this.wrongFileFormat) {
          this.checkBeforeSumbit = false;
        } else {
          this.checkBeforeSumbit = true;
        }
        console.log(this.$refs.files);
      },
      sendRequest() {
        let bodyFormData = new FormData();
        let formData = {
          Description: this.description,
          MailAdress: this.requesterMail,
          Subject: this.ticket.issue.subject,
          IssueId: this.ticket.issue.id,
        };
        console.log(this.requesterMail);
        let json = JSON.stringify(formData);
        const blob = new Blob([json], { type: "application/json" });
        bodyFormData.append("Details", blob);

        if (this.files) {
          this.files.forEach((el) => {
            bodyFormData.append(el.name, el, el.name);
          });
        }
        if (
          this.maxFileCount ||
          this.fileSizeEx ||
          this.wrongFileFormat ||
          this.adjError == true ||
          this.kidTicketAttach
        ) {
          return;
        } else {
          this.isSubmiting = true;
          axios({
            method: "POST",
            url: "https://www.biletdv.ru/customer/IBEServices/UpdateRedmineIssueByUser",
            data: bodyFormData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          })
            .then((res) => {
              if (res.status == 200) {
                this.showSuccess();
                this.description = "";
                this.files = null;
                this.isSubmiting = false;
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                store.dispatch("auth/logout");
                this.$router.push("/login");
              } else {
                console.log(error);
              }
            });
        }
      },
      redirectToOrder(orderNum) {
        axioCred
          .get(
            `https://www.biletdv.ru/customer/IBEServices/GetUserOrderByOrderNum?orderNum=${orderNum}`
          )
          .then((res) => {
            if (res.status == 200) {
              console.log(res);
              this.$router.replace({
                name: "Order",
                params: { order: res.data },
              });
            } else {
              console.log("error!");
            }
          });
      },
      getCreatedDate(date) {
        let created = new Date(date);
        let createdDay = created.getDate();
        let createdMonth = created.getMonth();
        let createdYear = created.getFullYear();
        let createdHours = function () {
          if (created.getHours() < 10) {
            return "0" + created.getHours();
          } else {
            return created.getHours();
          }
        };
        let createdMinutes = function () {
          if (created.getMinutes() < 10) {
            return "0" + created.getMinutes();
          } else {
            return created.getMinutes();
          }
        };
        return (
          createdDay +
          " " +
          this.month[createdMonth] +
          " " +
          createdYear +
          " " +
          createdHours() +
          ":" +
          createdMinutes()
        );
      },
      isStatusAssigned(name) {
        if (name == "assigned_to_id") {
          return true;
        } else {
          return false;
        }
      },
      getTicketStatus(num) {
        if (num == 1) {
          return "Заявка создана";
        } else if (num == 2) {
          return "Заявка в работе";
        } else if (num == 3) {
          return "Заявка успешно решена";
        } else if (num == 4) {
          return "Требуется обратная связь";
        } else if (num == 5) {
          return "Заявка закрыта";
        } else if (num == 6) {
          return "Отказ по заявке";
        }
      },
      getTicketStatusString(num) {
        if (num == "1") {
          return "Заявка создана";
        } else if (num == "2") {
          return "Заявка в работе";
        } else if (num == "3") {
          return "Заявка успешно решена";
        } else if (num == "4") {
          return "Требуется обратная связь";
        } else if (num == "5") {
          return "Заявка закрыта";
        } else if (num == "6") {
          return "Отказ по заявке";
        }
      },
      journalNameHandler(note) {
        switch (note) {
          case "status_id":
            return "Cтатус";
          case "done_ratio":
            return "Готовность";
          case "priority_id":
            return "Приоритет";
          case "estimated_hours":
            return "Оценка временных затрат";
          case "assigned_to_id":
            return "Назначена";
        }
      },
      journalValueHandler(name, oldValue, newValue) {
        if (oldValue == null) {
          return `на ${newValue} ч`;
        } else {
          if (name == "status_id") {
            return `с ${this.getTicketStatusString(
              oldValue
            )} на ${this.getTicketStatusString(newValue)}`;
          } else if (name == "done_ratio") {
            return `с ${oldValue}% на ${newValue}%`;
          }
        }
      },
    },
    created() {
      this.getUserTicket();
      this.getUserData();
    },
    directives: {
      ripple: Ripple,
    },
  });
</script>

<style lang="scss">
  .support-tickets__information {
    padding: 10px 10px 10px 10px;
    width: 100%;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }

  .support-tickets__information-header {
    font-size: 23px;
  }

  .support-tickets__information-status {
    margin-top: 15px;
  }

  .support-tickets__information-status__header {
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-status__text {
    margin-top: 5px;
  }

  .support-tickets__information-startdate {
    margin-top: 15px;
  }

  .support-tickets__information-startdate__header {
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-startdate__text {
    margin-top: 5px;
  }

  .support-tickets__information-enddate {
    margin-top: 15px;
  }

  .support-tickets__information-enddate__header {
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-enddate__text {
    margin-top: 5px;
  }

  .support-tickets__information-ordernumber {
    margin-top: 15px;
  }

  .support-tickets__information-ordernumber__header {
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-ordernumber__text {
    text-decoration: underline;
    color: #1867c0;
    font-weight: bold;
    margin-top: 5px;
  }

  .support-tickets__information-history {
    margin-top: 15px;
  }

  .support-tickets__information-history__header {
    margin-left: 10px;
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-history__usermessage {
    padding: 10px 10px 10px 10px;
    width: 100%;
    background: #e3fdea;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    margin-top: 15px;
    text-align: right;
  }

  .support-tickets__information-history__supportmessage {
    padding: 10px 10px 10px 10px;
    width: 100%;
    background: #e3f2fd;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    margin-top: 15px;
  }

  .support-tickets__information-description {
    margin-top: 15px;
  }

  .support-tickets__information-description__header {
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-description__text {
    margin-top: 5px;
    line-height: 22px;
    white-space: pre-wrap;
  }

  .support-tickets__information-attachments {
    margin-top: 15px;
  }

  .support-tickets__information-attachments__header {
    color: #939090;
    font-weight: bold;
  }

  .support-tickets__information-attachments__url {
    margin-top: 5px;
  }

  .support-tickets__information-attachments__url-text {
    color: #1867c0 !important;
    -webkit-tap-highlight-color: transparent;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
  }

  .support-tickets__changeble {
    margin-top: 25px;
  }

  .support-tickets__information-history__message {
    margin-top: 15px;
  }

  .support-tickets__information-history__message-text {
    white-space: pre-wrap;
  }
</style>
